import { Component, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormArray } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Clubstate } from 'src/app/interfaces/clubstate';
import { ClubstateService } from 'src/app/services/clubstate.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-clubstate',
  templateUrl: './clubstate.component.html',
  styleUrls: ['./clubstate.component.scss']
})
export class ClubstateComponent implements OnInit {
  /**
   * is the page loading?
   */
  loading: boolean = true;
  /**
   * The Form to edit/add States
   */
  stateForm: UntypedFormGroup;
  /**
   * The Array of clubstates
   */
  statesArray :Array<Clubstate>= [];
  /**
   * constructor
   * Init the Forms
   * @param fb 
   * @param clubstateService 
   * @param overlayService 
   */
  constructor(
    private fb: UntypedFormBuilder,
    private clubstateService: ClubstateService,
    private overlayService: OverlayService
  ) {

    this.stateForm = this.fb.group({
      states: this.fb.array([]),
    })

    this.clubstateService.getAllStatesForClientID().subscribe({
      next: (states: Array<Clubstate>) => {
        this.statesArray = states;
        states.forEach(state => {
          this.addStateWithValue(state.id, state.longname, state.shortcode, state.visible)
        });
        this.loading = false;
      },
      error: err => {
        this.loading = false;
      }
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit() {

  }
  /**
   * Get the State as anUntypedFormArray
   */
  get states(): UntypedFormArray {
    return this.stateForm.controls["states"] as UntypedFormArray;
  }
  /**
   * Add a new Form 
   */
  addState() {
    const stateForm = this.fb.group({
      id: [''],
      longname: ['', Validators.required],
      shortcode: ['', Validators.required],
      visible: [false, Validators.required]
    });
    this.states.push(stateForm);
  }
  /**
   * Add a new Form with data passed in
   * @param id 
   * @param longname 
   * @param shortcode 
   * @param visible 
   */
  addStateWithValue(id: string, longname: String, shortcode: String, visible: boolean) {
    const stateForm = this.fb.group({
      id: [id, Validators.required],
      longname: [longname, Validators.required],
      shortcode: [{ value: shortcode, disabled: true }, Validators.required],
      visible: [visible, Validators.required]
    });
    this.states.push(stateForm);
  }
  /**
   * Save the changes of the States
   * @returns 
   */
  saveChanges() {
    this.stateForm.markAllAsTouched();
    if (this.stateForm.invalid) {
      return;
    }
    let hasShownToast: boolean = false;

    this.states['controls'].forEach((control: FormGroup) => {
      control['controls'].shortcode.disable();
    });

    this.stateForm.getRawValue()['states'].forEach((element, index) => {
      if (element.id == '') {
        let state: Clubstate = {
          id: uuidv4(),
          clientId: 123,
          longname: element.longname,
          shortcode: element.shortcode,
          visible: Boolean(element.visible)
        }
        this.clubstateService.addNewState(state).subscribe({
          next: fromCreate => {
            if (hasShownToast === false) {
              hasShownToast = true;
              this.overlayService.openSnackBar("Clubstatus erfolgreich angelegt!")
            }
          },
          error: err => {
            console.log(err)
          }
        })
      } else {
        let state: Clubstate = {
          id: element.id,
          clientId: 123,
          longname: element.longname,
          shortcode: element.shortcode,
          visible: Boolean(element.visible)
        }
        this.clubstateService.editOneState(state).subscribe({
          next: fromUpdate => {
            if (hasShownToast === false) {
              hasShownToast = true;
              this.overlayService.openSnackBar("Clubstatus erfolgreich geändert!")
            }
          },
          error: err => {
            console.log(err)
          }
        })
      }
    });
  }
  /**
   * Delte a Clubstate
   * @param stateIndex 
   */
  deleteState(stateIndex) {
    if (this.stateForm.value.states[stateIndex].id != '') {
      this.clubstateService.delteState(this.stateForm.value.states[stateIndex].id).subscribe({
        next: fromDelete => {
          this.overlayService.openSnackBar("Clubstatus erfolgreich gelöscht!")
          this.states.removeAt(stateIndex)
        },
        error: err => {
          console.log(err)
        }
      })
    } else {
      this.states.removeAt(stateIndex)
      this.overlayService.openSnackBar("Clubstatus erfolgreich gelöscht!")
    }

  }
}
